// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"268":"8210e814","496":"8d8889c6","647":"da640597"}[chunkId] + ".chunk.js";
};